import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TextInputModalData, TextInputModalResult } from './text-input-modal.model';

@Component({
  selector: 'bhub-text-input-modal',
  templateUrl: './text-input-modal.component.html',
  styleUrls: ['./text-input-modal.component.scss'],
  standalone: false
})
export class TextInputModalComponent {
  text: string = '';
  
  style = {
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#000000',
    backgroundColor: '#ffffff',
    textAlign: 'left' as 'left' | 'center' | 'right'
  };

  constructor(
    public dialogRef: MatDialogRef<TextInputModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TextInputModalData
  ) {
    if (data.initialValue) {
      this.text = data.initialValue;
    }
    
    if (data.initialStyle) {
      this.style = {
        ...this.style,
        ...data.initialStyle
      };
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.data.required && !this.text.trim()) {
      return;
    }

    const result: TextInputModalResult = {
      text: this.text.trim(),
      style: { ...this.style }
    };

    this.dialogRef.close(result);
  }

  toggleBold(): void {
    this.style.fontWeight = this.style.fontWeight === 'bold' ? 'normal' : 'bold';
  }

  setAlignment(align: 'left' | 'center' | 'right'): void {
    this.style.textAlign = align;
  }

  getPreviewStyle(): any {
    return {
      'font-weight': this.style.fontWeight,
      'font-size': this.style.fontSize,
      'color': this.style.color,
      'background-color': this.style.backgroundColor,
      'text-align': this.style.textAlign
    };
  }

  isValidInput(): boolean {
    return !this.data.required || this.text.trim().length > 0;
  }
}